<script setup lang="ts">
import UiChangesItem from "./UiChangesItem.vue";

/** Étape 3 : les onglets à droite du plan (mêmes icônes que les bulles). */
const TABS = [
  { key: "layers", icon: "stack" },
  { key: "paperSpace", icon: "article" },
  { key: "blocks", icon: "cube" },
  { key: "observations", icon: "binoculars" },
  { key: "settings", icon: "sliders" },
] as const;
</script>

<template>
  <div>
    <p class="ui-intro">{{ $t("canvas:uiChanges.tabs.intro") }}</p>
    <div class="d-flex flex-column gap-3">
      <UiChangesItem
        v-for="tab in TABS"
        :key="tab.key"
        :icon="tab.icon"
        :title="$t(`canvas:settingsTabs.label.${tab.key}`)"
        :text="$t(`canvas:uiChanges.tabs.items.${tab.key}`)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-intro {
  margin: 0 0 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.75);
}
</style>
